/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_App_NameInputs */

const en_admin_settings_fields_app_name = /** @type {(inputs: Admin_Settings_Fields_App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Name`)
};

const zh_admin_settings_fields_app_name = /** @type {(inputs: Admin_Settings_Fields_App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用名称`)
};

/**
* | output |
* | --- |
* | "App Name" |
*
* @param {Admin_Settings_Fields_App_NameInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_app_name = /** @type {((inputs?: Admin_Settings_Fields_App_NameInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_App_NameInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_app_name(inputs)
	return zh_admin_settings_fields_app_name(inputs)
});
export { admin_settings_fields_app_name as "admin.settings.fields.app_name" }